import axios from "axios";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import config from "../../../../service/config";
import styles from "./esignWithEstamp.module.css";
import companyStore from "../../CompanyStore";
import { useAllProduct } from "../../../api-context/commonApiContext";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Spin } from "antd";

import { Modal, Button } from "react-bootstrap"; // Import Modal and Button from react-bootstrap
export const EsignWithEstamp = () => {
  const { eSignCoordinates, loader, setLoader, authTokens, isTokenValid, getNewTokens } = useAllProduct();
  const location = useLocation();
  const doc_id = location.pathname.split("/")[4];
  const [esignData, setEsignData] = useState([]);
  const [img, setimg] = useState([]);
  const [draggables, setDraggables] = useState([]);
  const [signStatus, setSignStatus] = useState("");
  const [kycInfo, setKycInfo] = useState([]);
  const [errors, setErrors] = useState({});
  const [states, setStates] = useState([]);
  const [articleCode, setArticleCode] = useState([]);
  const navigate = useNavigate();
  const [estampData, setEstampData] = useState({
    typeOfContract: "Operational",
    firstparty: "",
    state: "",
    secondparty: "",
    descriptionofDocument: "",
    articleCode: "",
    stampDutyAmount: "",
    considerationPrice: "",
    prtcptentty: [], // Initialize parties as an empty array
  });

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await axios.get(`${config.node_api_endpoint}/v2/estamp/getstates`);
        console.log("response-->", response.data[0]);
        setStates(response.data[0]);
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };

    fetchStates();
  }, []);

  useEffect(() => {
    const fetchArticleCode = async () => {
      try {
        // Fetch the article code based on the selected state code
        const response = await axios.get(
          `${config.node_api_endpoint}/v2/estamp/getarticlecode?code=${estampData.state}`,
        );
        console.log("Article Code Response:", response.data.articleCodes);
        setArticleCode(response?.data?.articleCodes);
      } catch (error) {
        console.error("Error fetching article code:", error);
      }
    };

    // Only fetch when the state has been updated
    if (estampData.state) {
      fetchArticleCode();
    }
  }, [estampData.state]);

  const lglcnstn = [
    "Resident Individual",
    "Public Ltd",
    "Private Ltd",
    "LLP",
    "Proprietorship",
    "Partnership",
    "Entity Created by Statute",
    "Trust",
    "HUF",
    "Co-op Society",
    "Association of Persons",
    "Government",
    "Self Help Group",
    "Non-Resident",
    "Foreign Company",
  ];

  const docType = ["Indian Entity", "Resident Individual", "Foreign Entity", "NRI/Foreign Individual"];

  const reltocntrct = ["Debtor", "Guarantor", "Co-Obligant", "Creditor", "Beneficiary"];

  const fetchData = async () => {
    const payload = {
      escrow_id: companyStore.escrowId,
    };

    try {
      setLoader(true);

      // Ensure token is valid before the first API call
      if (!isTokenValid(authTokens.idToken)) {
        console.log("Token invalid or expired, refreshing...");
        await getNewTokens();
        const updatedAuthTokens = JSON.parse(localStorage.getItem("authTokens"));
        if (!updatedAuthTokens?.idToken || !isTokenValid(updatedAuthTokens.idToken)) {
          console.error("Failed to refresh token or new token is invalid.");
          setLoader(false);
          return;
        }
        authTokens.idToken = updatedAuthTokens.idToken; // Update local reference
      }

      // First API call: Get company list
      const response = await axios.post(`${config.node_api_endpoint}/v2/company/list`, payload, {
        headers: {
          aws_cognito_id_token: authTokens.idToken,
          "Content-Type": "application/json",
        },
      });

      const data = response.data;
      if (!data || !Array.isArray(data) || data.length === 0) {
        console.log("No company data returned.");
        setKycInfo([]);
        setLoader(false);
        return;
      }

      // Extract all director_ids from the response
      const allDirectorIds = data.reduce((ids, item) => {
        if (item.director_ids && Array.isArray(item.director_ids)) {
          return [...ids, ...item.director_ids];
        }
        return ids;
      }, []);

      let kycResponse = { data: [] };
      if (allDirectorIds.length > 0) {
        // Re-check token validity before the second API call
        if (!isTokenValid(authTokens.idToken)) {
          console.log("Token expired before second call, refreshing...");
          await getNewTokens();
          const updatedAuthTokens = JSON.parse(localStorage.getItem("authTokens"));
          if (!updatedAuthTokens?.idToken || !isTokenValid(updatedAuthTokens.idToken)) {
            console.error("Failed to refresh token for second call.");
            setLoader(false);
            return;
          }
          authTokens.idToken = updatedAuthTokens.idToken;
        }

        // Second API call: Get KYC parties
        kycResponse = await axios.post(
          `${config.node_api_endpoint}/v2/company/kycparties`,
          { director_ids: allDirectorIds },
          {
            headers: {
              aws_cognito_id_token: authTokens.idToken,
              "Content-Type": "application/json",
            },
          },
        );
      }

      // Filter KYC data
      const filteredData =
        kycResponse?.data?.filter((party) => party.status === "approved" || party.status === "SUBMITTED") || [];
      setKycInfo(filteredData);
      setLoader(false);
    } catch (error) {
      console.error("Error in fetchData:", error);
      if (error.response?.data?.error === "Token has expired. Please log in again.") {
        console.log("Token expired during request, refreshing...");
        await getNewTokens();
        const updatedAuthTokens = JSON.parse(localStorage.getItem("authTokens"));
        if (updatedAuthTokens?.idToken && isTokenValid(updatedAuthTokens.idToken)) {
          return fetchData(); // Retry the entire fetch with the new token
        }
      }
      setLoader(false);
      // Optionally: Notify user of the error (e.g., via toast)
    }
  };

  useEffect(() => {
    if (authTokens.idToken.length > 0) fetchData();
  }, [companyStore, authTokens]);

  const coordinates = [
    { x: 290, y: 475 },
    { x: 180, y: 540 },
    { x: 60, y: 540 },
    { x: 300, y: 513 },
    { x: 180, y: 513 },
    { x: 60, y: 513 },
  ];

  useEffect(() => {
    if (authTokens && authTokens.idToken.length > 0) {
      axios
        .post(
          `${config.node_api_endpoint}/v1/esign/getdocument`,
          { doc_id },
          {
            headers: {
              aws_cognito_id_token: authTokens.idToken,
              // "Content-Type": "application/json",
            },
          },
        )
        .then((res) => {
          setimg(res.data.png_url);
          setEsignData(res.data.signing_parties);
          setSignStatus(res.data.status);
          var draggableArray = [];
          for (var i = 0; i < res?.data?.signing_parties?.length; i++) {
            var esignDataItem = res?.data?.signing_parties[i];
            var line_no = Math.floor(i / 4);
            draggableArray.push({
              name: esignDataItem.name,
              email: esignDataItem.email,
              x: coordinates[0].x - (i % 4) * 100,
              y: coordinates[0].y - line_no * 27,
              imageId: esignDataItem.imageId,
            });
          }
          setDraggables(draggableArray);
        });
    }
  }, [doc_id, authTokens]);

  // Update parties whenever esignData changes
  // useEffect(() => {
  //   const initialParties = esignData.map((d, index) => {
  //     const panDetails = kycInfo.find((info) => info.director_email === d.email);
  //     return {
  //       prtcptenttyId: index + 1,
  //       lglcnstn: "",
  //       reltocntrct: "",
  //       fulnm: d.name,
  //       cntrprtycntmobno: "",
  //       emlid: d.email,
  //       panno: panDetails?.kyc_details.actions[0].details.pan.id_number || "",
  //       partytyp: "",
  //       doi:panDetails?.kyc_details?.actions[0]?.details?.pan.dob.length>0? convertDate(panDetails?.kyc_details?.actions[0]?.details?.pan?.dob) || "" :"",
  //       // doi: panDetails?.kyc_details.actions[0].details.pan.dob || "",
  //     };
  //   });
  //   setEstampData((prevData) => ({
  //     ...prevData,
  //     prtcptentty: initialParties,
  //   }));
  // }, [esignData, kycInfo]);

  useEffect(() => {
    const sortedParties = esignData
      .sort((a, b) => {
        if (a.name === estampData.firstparty && b.name !== estampData.firstparty) {
          return -1;
        } else if (a.name !== estampData.firstparty && b.name === estampData.firstparty) {
          return 1;
        }

        if (a.name === estampData.secondparty && b.name !== estampData.secondparty) {
          return -1;
        } else if (a.name !== estampData.secondparty && b.name === estampData.secondparty) {
          return 1;
        }

        return 0;
      })
      .map((d, index) => {
        const panDetails = kycInfo.find((info) => info.director_email === d.email);

        return {
          prtcptenttyId: index + 1,
          fulnm: d.name,
          reltocntrct: "",
          emlid: d.email,
          cntrprtycntmobno: "",
          // panno: panDetails?.kyc_details?.actions[0].details?.pan?.id_number || "",
          panno:
            panDetails?.mode === "offline"
              ? panDetails?.director_pan
              : panDetails?.kyc_details
                ? panDetails?.kyc_details?.actions[0].details?.pan?.id_number
                : "",
          doi:
            panDetails?.mode === "offline"
              ? convertDateOffline(panDetails?.director_dob)
              : panDetails?.kyc_details?.actions[0]?.details?.pan.dob.length > 0
                ? convertDate(panDetails?.kyc_details?.actions[0]?.details?.pan?.dob)
                : "",

          // doi:
          //   panDetails?.kyc_details?.actions[0]?.details?.pan.dob.length > 0
          //     ? convertDate(panDetails?.kyc_details?.actions[0]?.details?.pan?.dob) || ""
          //     : "",
          lglcnstn: "",
          partytyp: "",
        };
      });

    setEstampData((prevData) => ({
      ...prevData,
      prtcptentty: sortedParties, // Update with sorted parties
    }));
  }, [esignData, kycInfo, estampData.firstparty, estampData.secondparty]); // Ensure the hook re-runs when these values change

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEstampData({ ...estampData, [name]: value });
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear error
  };

  const handlePartyChange = (e, index) => {
    const { name, value } = e.target;
    const updatedParties = [...estampData.prtcptentty];

    updatedParties[index] = { ...updatedParties[index], [name]: value };
    setEstampData({ ...estampData, prtcptentty: updatedParties });
    setErrors((prevErrors) => ({
      ...prevErrors,
      [`prtcptentty[${index}].${name}`]: "",
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isFormValid = validateForm();
    if (!isFormValid) {
      alert("Please fix the errors in the form before submitting.");
      return;
    }
    let SignatureSettings = {
      ModeOfAuthentication: 0,
      ModeOfSignature: "12",
    };
    const payload = {
      regType: "1",
      signFlag: "0",
      estampFlag: "Y",
      f2f: "Y",
      state: estampData.state,
      estampdtls: {
        firstparty: estampData.firstparty,
        secondparty: estampData.secondparty,
        stampDutyAmount: estampData.stampDutyAmount,
        considerationPrice: estampData.considerationPrice,
        descriptionofDocument: estampData.descriptionofDocument,
        articleCode: estampData.articleCode,
      },
      prtcptentty: estampData.prtcptentty,
      scrtydtls: null,
    };
    axios
      .post(
        `${config.node_api_endpoint}/v2/estamp/update`,
        { doc_id, payload, reason: "E-SignWithE-Stamp" },
        {
          headers: {
            aws_cognito_id_token: authTokens.idToken,
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        if (res.status === 200) {
          setLoader(true);
          return axios.post(
            `${config.node_api_endpoint}/v1/esign/sign_document`,
            {
              doc_id,
              sign_coordinates: eSignCoordinates,
              SignatureSettings: SignatureSettings,
              created_by: companyStore?.AdminEmail,
              escrow_id: companyStore?.escrowId,
            },
            {
              headers: {
                aws_cognito_id_token: authTokens.idToken,
                "Content-Type": "application/json",
              },
            },
          );
        } else {
          setLoader(false);
          throw new Error("Failed to update e-stamp");
        }
      })
      .then((signRes) => {
        if (signRes.status === 200) {
          setLoader(true);
          const urlToOpen = signRes.data.URL;

          const popupWindow = window.open(urlToOpen, "_blank", "width=800,height=600");

          // Check if the popup was opened, and if so, close it after 10 seconds
          const checkPopupInterval = setInterval(() => {
            if (popupWindow && !popupWindow.closed) {
              popupWindow.close();
              clearInterval(checkPopupInterval);
            }
          }, 20000); // Check every second

          setTimeout(() => {
            clearInterval(checkPopupInterval); // Clear interval if popup didn't open
          }, 20000); // Timeout after 10 seconds

          localStorage.removeItem("signCoordinates");
          setLoader(false);
          navigate(`/content/esign/esign-requested`);
        } else {
          setLoader(false);
          throw new Error("Failed to sign document");
        }
      })
      .catch((err) => {
        if (err.status === 503) {
          alert(err.response.data.message || "An error occurred");
          setLoader(false);
          navigate("/content/esign/esign/main");
        } else {
          alert(err.response.data.message || "An error occurred" || err.message);
          setLoader(false);
        }
        console.log("sign123-->", err);
      });
    // }
  };

  const validateForm = () => {
    const newErrors = {};

    // Basic field validations
    if (!estampData.firstparty) newErrors.firstparty = "First Party Name is required";
    if (!estampData.state) newErrors.state = "State is required";
    if (!estampData.secondparty) newErrors.secondparty = "Second Party Name is required";
    if (!estampData.descriptionofDocument) {
      newErrors.descriptionofDocument = "Description is required";
    } else if (estampData.descriptionofDocument.length < 3) {
      newErrors.descriptionofDocument = "Description must be at least 3 characters";
    } else if (estampData.descriptionofDocument.length > 100) {
      newErrors.descriptionofDocument = "Description must not exceed 100 characters";
    }

    if (!estampData.articleCode) newErrors.articleCode = "Article Code is required";

    // Validate Stamp Duty Amount
    if (!estampData.stampDutyAmount) {
      newErrors.stampDutyAmount = "Stamp Duty Amount is required";
    } else if (estampData.stampDutyAmount < 10) {
      newErrors.stampDutyAmount = "Stamp Duty Amount must be greater than 9";
    } else if (estampData.stampDutyAmount.toString().length > 19) {
      newErrors.stampDutyAmount = "Stamp Duty Amount must not exceed 19 characters";
    }

    // Validate Consideration Price
    if (!estampData.considerationPrice) {
      newErrors.considerationPrice = "Consideration Price is required";
    } else if (estampData.considerationPrice.toString().length > 19) {
      newErrors.considerationPrice = "Consideration Price must not exceed 19 characters";
    }

    // Validate unique "Creditor" and "Debtor" roles
    const roles = estampData.prtcptentty.map((party) => party.reltocntrct);
    const creditorCount = roles.filter((role) => role === "Creditor").length;
    const debtorCount = roles.filter((role) => role === "Debtor").length;

    if (creditorCount !== 1) {
      alert("There must be exactly one Creditor.");
      newErrors.creditor = "There must be exactly one Creditor.";
    }
    if (debtorCount !== 1) {
      alert("There must be exactly one Debtor.");
      newErrors.debtor = "There must be exactly one Debtor.";
    }

    // Validate prtcptentty (party) fields
    estampData.prtcptentty.forEach((party, index) => {
      if (!party.lglcnstn) newErrors[`prtcptentty[${index}].lglcnstn`] = "Legal Constitution is required";
      if (!party.reltocntrct) newErrors[`prtcptentty[${index}].reltocntrct`] = "Relationship to Contract is required";
      if (!party.cntrprtycntmobno) {
        newErrors[`prtcptentty[${index}].cntrprtycntmobno`] = "Mobile number is required";
      } else if (!/^[6-9]\d{9}$/.test(party.cntrprtycntmobno)) {
        newErrors[`prtcptentty[${index}].cntrprtycntmobno`] =
          "Mobile number must be a valid 10-digit Indian number starting with 6-9";
      }
      if (!party.panno) {
        newErrors[`prtcptentty[${index}].panno`] = "PAN number is required";
      } else if (party.panno.length !== 10) {
        newErrors[`prtcptentty[${index}].panno`] = "PAN number must be exactly 10 characters";
      } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(party.panno)) {
        newErrors[`prtcptentty[${index}].panno`] = "PAN number format is invalid (e.g., ABCDE1234F)";
      }
      if (!party.partytyp) newErrors[`prtcptentty[${index}].partytyp`] = "Party Type is required";
      if (!party.doi) newErrors[`prtcptentty[${index}].doi`] = "DOB is required";
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  function convertDate(str) {
    const [day, month, year] = str?.split("/"); // Split the string by "/"
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  function convertDateOffline(str) {
    if (!str) return ""; // Handle undefined or null input

    // Check if the string contains a dash ("-") or slash ("/")
    if (str.includes("-")) {
      // Assume the input is already in YYYY-MM-DD format
      return str;
    } else if (str.includes("/")) {
      // Convert DD/MM/YYYY to YYYY-MM-DD
      const [day, month, year] = str.split("/");
      return `${year}-${month}-${day}`;
    }

    console.warn("Unexpected date format:", str);
    return ""; // Return an empty string for invalid formats
  }

  const handleDateChange = (date, index) => {
    if (date) {
      const formattedDate = dayjs(date).format("YYYY-MM-DD");

      const updatedParties = [...estampData.prtcptentty];

      updatedParties[index] = { ...updatedParties[index], doi: formattedDate };
      setEstampData({ ...estampData, prtcptentty: updatedParties });

      setErrors((prevErrors) => ({
        ...prevErrors,
        [`prtcptentty[${index}].doi`]: "",
      }));
    }
  };

  function SubmittedFormModal() {
    const [show, setShow] = useState(true); // State to control modal visibility
    const navigate = useNavigate(); // Hook for navigation

    const handleClose = () => {
      setShow(false);
      navigate("/content/esign/esign/main");
    };

    return (
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>Form Already Submitted</Modal.Title>
        </Modal.Header>
        <Modal.Body>You cannot resubmit the already filled form.</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose} style={{ backgroundColor: "rgb(35,72,171)", border: "none" }}>
            Return to Esign List
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <Spin
      size="large"
      tip="Loading..."
      spinning={loader}
      className="d-flex justify-content-center align-items-center w-100 h-100"
      wrapperClassName="spin-nested-loading"
      style={{ maxHeight: "none" }}
    >
      {signStatus === "draft" ? (
        <div className={`${styles.pageContainer} mt-4`}>
          <div className={` d-flex mb-2`}>
            <img
              className={`${styles.arrowNarrowLeftIcon} ${styles.cursorIcon} pe-2`}
              onClick={() => {
                navigate(-1);
              }}
              alt=""
              src="/arrownarrowleft.svg"
            />
            <div
              className={`${styles.back} ${styles.cursorIcon}`}
              onClick={() => {
                navigate(-1);
              }}
            >
              Back
            </div>
          </div>
          <div className={"mb-4 mt-3"}>
            <div
              className={`${styles.escrowName}`}
              title={companyStore.escrowName.length > 50 ? companyStore.escrowName : ""}
            >
              {companyStore.escrowName.length > 50
                ? companyStore.escrowName.slice(0, 50) + "..."
                : companyStore.escrowName}
            </div>
          </div>
          <form onSubmit={handleSubmit}>
            <h4>Type of Contract</h4>
            <div className="mb-4 w-50">
              <select
                name="typeOfContract"
                className="form-select"
                value={estampData.typeOfContract}
                onChange={handleChange}
                disabled={"true"}
              >
                <option value="Operational">Operational</option>
                {/* <option value="Financial">Financial</option> */}
              </select>
            </div>

            <h4>E-stamp Sections</h4>
            <div className="row mb-3">
              <div className="d-flex justify-content-between col-md-6">
                <label className="form-label">
                  First Party Name<span style={{ color: "red" }}>*</span>
                </label>
                <div className="w-50">
                  <select
                    name="firstparty"
                    className="form-select"
                    value={estampData.firstparty}
                    onChange={handleChange}
                    style={{ borderRadius: "12px", borderColor: errors.firstparty ? "#B3261E" : "" }}
                  >
                    <option value="">Select First Party Name</option>
                    {esignData.map((party, index) => (
                      <option key={index} value={party.name}>
                        {party.name}
                      </option>
                    ))}
                  </select>
                  {errors.firstparty && <div style={{ color: "#B3261E" }}>{errors.firstparty}</div>}
                </div>
              </div>
              <div className="d-flex justify-content-between col-md-6">
                <label className="form-label">
                  State<span style={{ color: "red" }}>*</span>
                </label>
                <div className="w-50">
                  <select
                    name="state"
                    className="form-select"
                    value={estampData.state}
                    onChange={handleChange}
                    style={{ borderRadius: "12px", borderColor: errors.state ? "#B3261E" : "" }}
                  >
                    <option>Please Select</option>
                    {states.map((state) => (
                      <option key={state.value} value={state.value}>
                        {state.description}
                      </option>
                    ))}
                  </select>
                  {errors.state && <div style={{ color: "#B3261E" }}>{errors.state}</div>}
                </div>
              </div>
            </div>

            <div className="row mb-3">
              <div className="d-flex justify-content-between col-md-6">
                <label className="form-label">
                  Second Party Name<span style={{ color: "red" }}>*</span>
                </label>
                <div className="w-50">
                  <select
                    name="secondparty"
                    className="form-select"
                    value={estampData.secondparty}
                    onChange={handleChange}
                    style={{ borderRadius: "12px", borderColor: errors.secondparty ? "#B3261E" : "" }}
                  >
                    <option value="">Select Second Party Name</option>
                    {esignData
                      .filter((party) => party.name !== estampData.firstparty)
                      .map((party, index) => (
                        <option key={index} value={party.name}>
                          {party.name}
                        </option>
                      ))}
                  </select>
                  {errors.secondparty && <div style={{ color: "#B3261E" }}>{errors.secondparty}</div>}
                </div>
              </div>
              <div className="d-flex justify-content-between col-md-6">
                <label className="form-label">
                  Description of Document<span style={{ color: "red" }}>*</span>
                </label>
                <div className="w-50">
                  <input
                    type="text"
                    className="form-control"
                    name="descriptionofDocument"
                    value={estampData.descriptionofDocument}
                    onChange={handleChange}
                    placeholder="Enter Description"
                    style={{ borderRadius: "12px", borderColor: errors.descriptionofDocument ? "#B3261E" : "" }}
                  />
                  {errors.descriptionofDocument && (
                    <div style={{ color: "#B3261E" }}>{errors.descriptionofDocument}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">
                  Article Code<span style={{ color: "red" }}>*</span>
                </label>
                <select
                  name="articleCode"
                  className="form-select custom-dropdown"
                  value={estampData.articleCode}
                  onChange={handleChange}
                  style={{ borderRadius: "12px", borderColor: errors.articleCode ? "#B3261E" : "" }}
                >
                  <option value="">Please Select</option>
                  {articleCode.map((option) => (
                    <option key={option.value} value={option.value} title={option.description}>
                      {option.description}
                    </option>
                  ))}
                </select>
                {errors.articleCode && <div style={{ color: "#B3261E" }}>{errors.articleCode}</div>}
              </div>
              <div className="col-md-4">
                <label className="form-label">
                  Stamp Duty Amount<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  name="stampDutyAmount"
                  value={estampData.stampDutyAmount}
                  onChange={handleChange}
                  placeholder="Enter Stamp Duty Amount"
                  style={{ borderRadius: "12px", borderColor: errors.stampDutyAmount ? "#B3261E" : "" }}
                />
                {errors.stampDutyAmount && <div style={{ color: "#B3261E" }}>{errors.stampDutyAmount}</div>}
              </div>
              <div className="col-md-4">
                <label className="form-label">
                  Consideration Price<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  name="considerationPrice"
                  value={estampData.considerationPrice}
                  onChange={handleChange}
                  placeholder="Enter Consideration Price"
                  style={{ borderRadius: "12px", borderColor: errors.considerationPrice ? "#B3261E" : "" }}
                />
                {errors.considerationPrice && <div style={{ color: "#B3261E" }}>{errors.considerationPrice}</div>}
              </div>
            </div>

            <h4>E-stamp Participant Details</h4>
            {/* {esignData.map((party, index) => { */}
            {estampData.prtcptentty.map((party, index) => {
              // Find the corresponding PAN info by matching the director_email
              const panDetails = kycInfo.find((info) => info.director_email === party.email);

              return (
                <div key={index}>
                  <div className="d-flex justify-content-between">
                    <h4>Party {index + 1}</h4>
                  </div>
                  <div className="row mb-3">
                    <div className="d-flex justify-content-between col-md-6">
                      <label className="form-label">
                        Legal Constitution of the Party<span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="w-50">
                        <select
                          name="lglcnstn"
                          className="form-select"
                          onChange={(e) => handlePartyChange(e, index)}
                          style={{
                            borderRadius: "12px",
                            borderColor: errors[`prtcptentty[${index}].lglcnstn`] ? "#B3261E" : "",
                          }}
                        >
                          <option>Please Select</option>
                          {/* Replace with your actual legal constitution options */}
                          {lglcnstn.map((type, idx) => (
                            <option key={idx} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                        {errors[`prtcptentty[${index}].lglcnstn`] && (
                          <div style={{ color: "#B3261E" }}>{errors[`prtcptentty[${index}].lglcnstn`]}</div>
                        )}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between col-md-6">
                      <label className="form-label">
                        Relationship of Party<span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="w-50">
                        <select
                          name="reltocntrct"
                          className="form-select"
                          // Set the initial value or default selection here (optional)
                          // value={party.reltocntrct || ""}
                          onChange={(e) => handlePartyChange(e, index)}
                          style={{
                            borderRadius: "12px",
                            borderColor: errors[`prtcptentty.reltocntrct`] ? "#B3261E" : "",
                          }}
                        >
                          <option>Please Select</option>
                          {/* Replace with your actual relationship options */}
                          {reltocntrct.map((type, idx) => (
                            <option key={idx} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                        {errors[`prtcptentty.reltocntrct`] && (
                          <div style={{ color: "#B3261E" }}>{errors[`prtcptentty.reltocntrct`]}</div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="d-flex justify-content-between col-md-6">
                      <label className="form-label">
                        Contact Person Name<span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="w-50">
                        <input
                          type="text"
                          className="form-control"
                          name="fulnm"
                          value={party.fulnm}
                          placeholder="Enter Contact Name"
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-between col-md-6">
                      <label className="form-label">
                        Mobile<span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="w-50">
                        <input
                          type="number"
                          className="form-control"
                          name="cntrprtycntmobno"
                          onChange={(e) => handlePartyChange(e, index)}
                          placeholder="Enter Mobile Number"
                          style={{
                            borderRadius: "12px",
                            borderColor: errors[`prtcptentty[${index}].cntrprtycntmobno`] ? "#B3261E" : "",
                          }}
                        />
                        {errors[`prtcptentty[${index}].cntrprtycntmobno`] && (
                          <div style={{ color: "#B3261E" }}>{errors[`prtcptentty[${index}].cntrprtycntmobno`]}</div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="d-flex justify-content-between col-md-6">
                      <label className="form-label">
                        Email<span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="w-50">
                        <input
                          type="text"
                          className="form-control"
                          name="emlid"
                          value={party.emlid}
                          placeholder="Enter Email Address"
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-between col-md-6">
                      <label className="form-label">
                        PAN<span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="w-50">
                        <input
                          type="text"
                          className="form-control"
                          name="panno"
                          // value={
                          //   panDetails?.kyc_details.actions[0].details.pan.id_number?.length > 0
                          //     ? panDetails?.kyc_details.actions[0].details.pan.id_number
                          //     : party.panno
                          // }
                          // value={panDetails?.kyc_details.actions[0].details.pan.id_number || ""}
                          value={party?.panno}
                          onChange={(e) => handlePartyChange(e, index)}
                          placeholder="Enter PAN"
                          style={{
                            borderRadius: "12px",
                            borderColor: errors[`prtcptentty[${index}].panno`] ? "#B3261E" : "",
                          }}
                        />
                        {errors[`prtcptentty[${index}].panno`] && (
                          <div style={{ color: "#B3261E" }}>{errors[`prtcptentty[${index}].panno`]}</div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="d-flex justify-content-between col-md-6">
                      <label className="form-label">
                        Party Type<span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="w-50">
                        <select
                          name="partytyp"
                          className="form-select"
                          value={party.partytyp}
                          onChange={(e) => handlePartyChange(e, index)}
                          style={{
                            borderRadius: "12px",
                            borderColor: errors[`prtcptentty[${index}].partytyp`] ? "#B3261E" : "",
                          }}
                        >
                          <option>Please Select</option>
                          {docType.map((type, idx) => (
                            <option key={idx} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                        {errors[`prtcptentty[${index}].partytyp`] && (
                          <div style={{ color: "#B3261E" }}>{errors[`prtcptentty[${index}].partytyp`]}</div>
                        )}
                      </div>
                    </div>
                    {/* <div className="d-flex justify-content-between col-md-6">
                  <label className="form-label">
                    Date of Birth<span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="w-50">
                    <input
                      type="text"
                      className="form-control"
                      name="doi"
                      placeholder="YYYY-MM-DD"
                      value={party?.doi}
                      // value={party.doi}
                      onChange={(e) => handlePartyChange(e, index)}
                      // placeholder="Enter PAN"
                      style={{
                        borderRadius: "12px",
                        borderColor: errors[`prtcptentty[${index}].panno`] ? "#B3261E" : "",
                      }}
                      // disabled={true}
                    />
                    {errors[`prtcptentty[${index}].panno`] && (
                      <div style={{ color: "#B3261E" }}>{errors[`prtcptentty[${index}].panno`]}</div>
                    )}
                  </div>
                </div> */}
                    <div className="d-flex justify-content-between col-md-6">
                      <label className="form-label">
                        Date of Birth<span style={{ color: "red" }}>*</span>
                      </label>
                      <div>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            name="doi"
                            // className="w-0"
                            value={party?.doi ? dayjs(party?.doi) : null}
                            maxDate={dayjs()}
                            onChange={(date) => handleDateChange(date, index)}
                            renderInput={(params) => <TextField {...params} />}
                            sx={{
                              "& .MuiInputBase-root": {
                                width: "410px",
                                height: "35px",
                                borderRadius: "12px",
                              },
                            }}
                          />
                        </LocalizationProvider>
                        {errors[`prtcptentty[${index}].doi`] && (
                          <div style={{ color: "#B3261E" }}>{errors[`prtcptentty[${index}].doi`]}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            <div className="d-flex justify-content-end">
              <button type="submit" className="btn btn-primary mt-3 mb-2 w-25" style={{ backgroundColor: "#2348AB" }}>
                Proceed
              </button>
            </div>
          </form>
        </div>
      ) : (
        <SubmittedFormModal />
      )}
    </Spin>
  );
};
